import { INVOICE_REPORT_TYPE } from "../../../core/constants/erpConstants";
import { helperServices } from "../../../shared/helper/index";
import history from "../../../shared/utils/history";
import { apiFetch } from "../../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Helper: Build Headers --------------------
function buildHeaders(contentType = "application/json") {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: contentType,
    "Content-Type": contentType,
    Authorization: accessToken,
  };
}

// -------------------- ERP Services --------------------

// Get Sales Order for Visit
export async function getSalesOrderforVisit(patientId, visitId, locationId) {
  const url = `${basePath}/v2/salesOrderDetails/${patientId}?visitId=${visitId}&locationIds=${locationId}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Get Customer Advance Payments
export async function getERPCustomerAdvPayments(
  patientId,
  visitId,
  locationId,
  fromDate,
  toDate,
  searchQuery
) {
  const params = new URLSearchParams();
  if (patientId) params.append("patientId", patientId);
  if (visitId) params.append("visitId", visitId);
  if (locationId) params.append("locationIds", locationId);
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (searchQuery) params.append("searchQuery", searchQuery);

  const url = `${basePath}/v2/totalAdvances?${params.toString()}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Get Customer Details
export async function getERPCustomerDetails(patientId) {
  const url = `${basePath}/v1/patientProfile?patientId=${patientId}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Get Invoices
// export async function getInvoices(
//   patientId,
//   visitId,
//   locationId,
//   ticketIds,
//   fromDate,
//   toDate
// ) {
//   const params = new URLSearchParams();
//   if (ticketIds) params.append("ticketIds", ticketIds);
//   if (patientId) params.append("patientId", patientId);
//   if (visitId) params.append("visitId", visitId);
//   if (fromDate) params.append("fromDate", fromDate);
//   if (toDate) params.append("toDate", toDate);
//   if (locationId) params.append("locationIds", locationId);

//   const url = `${basePath}/v2/invoices?${params.toString()}`;
//   return apiFetch(url, { method: "GET", headers: buildHeaders() });
// }

export async function getInvoices(payload) {
  const {
    ticketIds,
    patientId,
    visitId,
    fromDate,
    toDate,
    locationIds,
    searchQuery,
    billNumber,
    erpCustId
  } = payload;

  // Build query params
  const params = new URLSearchParams();

  if (ticketIds) params.append("ticketIds", ticketIds);
  if (patientId) params.append("patientId", patientId);
  if (visitId) params.append("visitId", visitId);
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (locationIds) params.append("locationIds", locationIds);
  if (searchQuery) params.append("searchQuery", searchQuery);
  if (billNumber) params.append("billNumber", billNumber);
  if (erpCustId && erpCustId!=null && erpCustId!=undefined) params.append("erpCustId", erpCustId);

  const url = `${basePath}/v2/invoices?${params.toString()}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}


// export async function getInvoices(payload) {
//   const url = `${basePath}/v2/invoices`;
//   return apiFetch(url, {
//     method: "POST",
//     headers: buildHeaders(),
//     body: JSON.stringify(payload),
//   });
// }


// Get Product List
export async function getProductList(product, patientId, visitId, locationId, onlyBillable) {
  if (onlyBillable == null || onlyBillable == undefined) {
    onlyBillable = false;
  }
  const queryParams = new URLSearchParams();
  if (product != null && product !== "") queryParams.append("product", product);
  if (locationId != null && locationId !== "" && (!Array.isArray(locationId) || locationId.length > 0)) {
    queryParams.append("locationIds", locationId);
  }
  if (patientId != null && patientId !== "") queryParams.append("patientId", patientId);
  if (visitId != null && visitId !== "") queryParams.append("visitId", visitId);
  queryParams.append("onlyBillable", onlyBillable);
  const url = `${basePath}/v2/products?${queryParams.toString()}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Get All Bank Details
export async function getAllBankDetails() {
  const url = `${basePath}/v2/banks`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Save Patient Payment Info
export async function savePatientPaymentInfo(locationId, patientPaymentInfo) {
  const url = `${basePath}/v2/advancePayment?locationId=${locationId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(patientPaymentInfo),
  });
}

// Delete Row ERP Service
export async function deleteRowErpService(patientId, visitId, soId, soLineId,actiontype,payload) {
  const url = `${basePath}/v2/so/delete?patientId=${patientId}&visitId=${visitId}&soId=${soId}&soLineId=${soLineId}&actionType=${actiontype}`;
  return apiFetch(url, 
    { method: "DELETE", 
    headers: {
      ...buildHeaders(),
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload ?? {}),
  }); 
}

// Update Service List
export async function UpdateserviceListData(
  patientId,
  visitId,
  locationId,
  procedure
) {
  const url = `${basePath}/v2/so/update?patientId=${patientId}&visitId=${visitId}&locationId=${locationId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(procedure),
  });
}

// Generate Patient Invoice
export async function generatePatientInvoice(
  locationId,
  invoiceDeatils,
  erpCustId
) {
  const url = `${basePath}/v2/generateInvoice?locationId=${locationId}&erpCustId=${erpCustId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(invoiceDeatils),
  });
}

// Get All Outstanding Bills
export async function getAllOutstandingBills(
  page,
  size,
  locationId,
  erpCustId,
  showConsoldiatedInv,
  isKpCash
) {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (size) params.append("size", size);
  params.append("locationIds", locationId);
  if (erpCustId) params.append("erpCustId", erpCustId);
  if (showConsoldiatedInv!=null && showConsoldiatedInv!=undefined) params.append("showConsoldiatedInv", showConsoldiatedInv);
  if (isKpCash!=null && isKpCash!=undefined) params.append("isKpCash", isKpCash);

  console.log("Outstanding API : ", params.toString());
  
  const url = `${basePath}/v2/bills/uncleared?${params.toString()}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Validate Patient Overall Status
export async function validatePatientOverallStatus(
  patientId,
  visitId,
  erpCustId
) {
  const url = `${basePath}/v1/validatePatientStatus?patientId=${patientId}&visitId=${visitId}&erpCustId=${erpCustId}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// Master Location Details
export async function getMasterLocationDetails() {
  const url = `${basePath}/v2/masterlocation/all`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

// -------------------- PDF Services --------------------

// Get Invoice PDF
export async function getInvoicePDF(
  ticketId,
  visitId,
  customerId,
  reportType,
  locationIds
) {
  const params = new URLSearchParams();
  if (ticketId) params.append("ticketId", ticketId);
  if (visitId) params.append("visitId", visitId);
  if (customerId) params.append("customerId", customerId);
  if (reportType) params.append("reportType", reportType);
  if (locationIds) params.append("locationIds", locationIds);

  const url = `${basePath}/v2/invoice/pdf?${params.toString()}`;
  const acceptType =
    reportType === INVOICE_REPORT_TYPE.CONSOLIDATED
      ? "text/html"
      : "application/pdf";
  return apiFetch(url, { method: "POST", headers: buildHeaders(acceptType) });
}

// Get Invoice PDF Object (raw response for .json/.blob)
export async function getInvoicePDFObject(
  ticketId,
  visitId,
  customerId,
  reportType,
  locationIds
) {
  const params = new URLSearchParams();
  if (ticketId) params.append("ticketIds", ticketId);
  if (visitId) params.append("visitIds", visitId);
  if (customerId) params.append("customerIds", customerId);
  if (reportType) params.append("reportType", reportType);
  if (locationIds) params.append("locationIds", locationIds);

  const url = `${basePath}/v2/invoice/pdf/object?${params.toString()}`;
  const acceptType =
    reportType === INVOICE_REPORT_TYPE.CONSOLIDATED
      ? "text/html"
      : "application/pdf";
  return apiFetch(url, { method: "POST", headers: buildHeaders(acceptType) });
}

export async function getQuotationPDFObject(quoteId) {
  const url = `${basePath}/v2/quotation/pdf/object?quoteId=${encodeURIComponent(quoteId)}`;
  return apiFetch(url, { method: "POST", headers: buildHeaders() });
}

// Get Receipt PDF Object
export async function getReceiptPDFObject(
  receiptId,
  visitId,
  patientId,
  paymentInfo
) {
  const params = new URLSearchParams();
  if (receiptId) params.append("receiptId", receiptId);
  if (visitId) params.append("visitId", visitId);
  if (patientId) params.append("patientId", patientId);

  const url = `${basePath}/v2/receipt/pdf/object?${params.toString()}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(paymentInfo),
  });
}

// Print Invoice PDF
export async function printInvPDF(fileData) {
  const url = `http://localhost:9090/api/print-pdf`;
  return apiFetch(url, {
    method: "POST",
    headers: { Authorization: helperServices.getAuthorization() },
    body: fileData,
  });
}

// -------------------- Invoice Settlement --------------------
export async function settleInvoices(patientId, visitId, invSettlementDetails) {
  const url = `${basePath}/v2/invoice/settle?patientId=${patientId}&visitId=${visitId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(invSettlementDetails),
  });
}

// -------------------- Payment Requests --------------------
export async function getPaymentRequests(visitId, status) {
  const params = new URLSearchParams();
  if (visitId) params.append("visitId", visitId);
  if (status) params.append("status", status);

  const url = `${basePath}/v2/payment/request?${params.toString()}`;
  return apiFetch(url, { method: "GET", headers: buildHeaders() });
}

export async function savePaymentRequest(
  patientId,
  visitId,
  hmsPaymentRequest
) {
  const url = `${basePath}/v2/payment/request?patientId=${patientId}&visitId=${visitId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(hmsPaymentRequest),
  });
}

export async function updatePaymentRequest(hmsPaymentRequest) {
  const url = `${basePath}/v2/payment/request`;
  return apiFetch(url, {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(hmsPaymentRequest),
  });
}

export async function deletePaymentRequest(paymentRequestId, visitId) {
  const url = `${basePath}/v2/payment/request/delete/${paymentRequestId}?visitId=${visitId}`;
  return apiFetch(url, { method: "DELETE", headers: buildHeaders() });
}

// Get MoveToBilling
export async function getFinalBill(request) {
  const url = `${basePath}/v2/moveToBilling`;
  return apiFetch(url, { method: "POST", headers: buildHeaders(), body: JSON.stringify(request), });
}

// Update KpCash-KPCredit Invoice
export async function updateKpCashKPCreditInvoiceConvertion(ticketId, isKpCash) {
  const url = `${basePath}/v2/invoice/convert/kpCashcredit?ticketId=${ticketId}&isKpCash=${isKpCash}`;
  return apiFetch(url, { method: "PATCH", headers: buildHeaders() });
}

export async function removeInvoice(invoiceObj, userName) {
  const url = `${basePath}/v2/invoice/removeInvoice?userName=${userName}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(invoiceObj),
  });
}

// Generate Patient Invoice Quotation
export async function generatePatientInvoiceQuotation(
  locationId,
  invoiceDeatils,
  erpCustId   
) {
  const url = `${basePath}/v2/generateInvoiceQuotation?locationId=${locationId}&erpCustId=${erpCustId}`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(invoiceDeatils),
  });
}

// Serach Patient Invoice Quotation
export async function searchInvoiceQuotation(quoteDetails) {
  const url = `${basePath}/v2/quotation/list`;
  return apiFetch(url, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(quoteDetails),
  });
}

// -------------------- Export --------------------
export const erpServices = {
  getSalesOrderforVisit,
  getERPCustomerAdvPayments,
  getERPCustomerDetails,
  getInvoices,
  getProductList,
  getAllBankDetails,
  savePatientPaymentInfo,
  generatePatientInvoice,
  deleteRowErpService,
  UpdateserviceListData,
  getAllOutstandingBills,
  validatePatientOverallStatus,
  getMasterLocationDetails,
  getInvoicePDF,
  printInvPDF,
  settleInvoices,
  getPaymentRequests,
  savePaymentRequest,
  updatePaymentRequest,
  deletePaymentRequest,
  getInvoicePDFObject,
  getQuotationPDFObject,
  getReceiptPDFObject,
  getFinalBill,
  updateKpCashKPCreditInvoiceConvertion,
  removeInvoice,
  generatePatientInvoiceQuotation,
  searchInvoiceQuotation,
};
